import React from 'react';
import { useDispatch } from 'react-redux';
import { clearUser } from '../../../../userSlice';
import { clearTokens } from '../../../utils/apiUtils';
import { useBrand } from '../../../../brands/contexts/BrandContext';
import './AccountActivationPending.scss';

const AccountActivationPending: React.FC = () => {
  const dispatch = useDispatch();
  const { brand } = useBrand();

  // Получаем путь к логотипу из конфигурации бренда
  const getAuthLogo = () => {
    return `${process.env.PUBLIC_URL}/${brand.logos.auth}`;
  };

  const handleLogout = () => {
    console.log('Logout button clicked');
    try {
      clearTokens();
      dispatch(clearUser());
      console.log('clearUser dispatched successfully');
      // Принудительно обновляем страницу для синхронизации с useAuth хуком
      window.location.href = '/auth';
    } catch (error) {
      console.error('Error during logout:', error);
    }
  };

  return (
    <div id='auth-page'>
      <div className='auth-page-container container d-flex flex-column align-items-center justify-content-center'>
        <img src={getAuthLogo()} alt="logo" />
        <div className='auth-page-form d-flex flex-column align-items-center justify-content-center'>
          <div className='activation-pending-content'>
            <div className='activation-icon'>⏳</div>
            <h2>Ваш аккаунт не активирован</h2>
            <p>Ожидайте активации, обычно занимает от нескольких часов, до трех рабочих дней.</p>
            <div className='activation-info'>
              <p><strong>Что происходит дальше?</strong></p>
              <ul>
                <li>Администратор проверяет ваши данные</li>
                <li>Активирует ваш аккаунт</li>
              </ul>
            </div>
            <div className='contact-info'>
              <p>Если у вас есть вопросы, обратитесь к администратору системы.</p>
            </div>

            <div className='logout-section'>
              <button
                type="button"
                className="logout-button"
                onClick={handleLogout}
              >
                Выйти из аккаунта
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountActivationPending;
